/*
|--------------------------------------------------------------------------
| App Instance
|--------------------------------------------------------------------------
|
*/

define('app',['config', 'helpers', 'lodash'], function (config, helpers, _) {

    "use strict";

    return _.extend({}, config, helpers);
    
});
